import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LargereceiptService } from '../service/largereceipt.service';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import { DownloadLargeReceipt, IDownloadLargeReceipt,IDownloadLargeReceiptHF
  , IMessageDetails, ResultContent, IReceiptDownloadDetails,ResultContent_DownloadAuthenticateReceipt } from '../class/largereceipt';
import { SubSink } from 'subsink';
import { AppError } from '../common/class/app-error';
import { TranslationLoaderService } from '../common/translation-loader.service';
import { UserSessionService } from '../common/user-session.service';
import { CommonUtilService } from '../service/common-util.service';

@Component({
  selector: 'app-download-authenticate-receipt',
  templateUrl: './download-authenticate-receipt.component.html',
  styleUrls: ['./download-authenticate-receipt.component.scss']
})
export class DownloadAuthenticateReceiptComponent implements OnInit {
  private subs = new SubSink();
  messageId!: string;
  public  resultContentObj=new ResultContent();
  public  resultContentObjDownload=new ResultContent_DownloadAuthenticateReceipt();
  public appLang = '';
  MessageDetailsResponse:string;
  data: any;
  messageDetailsSnapShot:IMessageDetails;
  IsFileDownloaded:boolean;
  IsFileAlreadyDownloaded:boolean;
  IsReceiptExpired:boolean;
  historyId:string;
  responseMessage:string;
  authenticatedReceiptDownloadDetailsSnapShot:IReceiptDownloadDetails
  receiptVerifiedEmailDownloadMaxHours:number;
  receiptExpiredNote:string;
  constructor(private largeReceiptService: LargereceiptService,private http: HttpClient,private router:Router, private route: ActivatedRoute
    ,private langLoaderSvc: TranslationLoaderService
    ,private user: UserSessionService
    ,private langSvc: TranslateService
    ,private commonUtilSvc:CommonUtilService) { 

      this.route.params.subscribe( params => this.historyId=(params.historyId));
      
      if(this.historyId==undefined)
          this.historyId='0';
      localStorage.setItem("HistoryId",this.historyId);
    }

  ngOnInit(): void {
    
    if(this.route.snapshot.data.messageDetailsByHistoryId!=undefined
      && this.route.snapshot.data.authenticatedReceiptDownloadDetails!=undefined
      )
    {
      this.messageDetailsSnapShot=this.route.snapshot.data.messageDetailsByHistoryId;
      this.resultContentObj=this.messageDetailsSnapShot.ResultContent;
      this.appLang=(this.resultContentObj.Language==null)?'en-us':this.resultContentObj.Language;
      this.messageId=this.resultContentObj.MessageId;
      localStorage.setItem("MessageId",this.messageId);
      localStorage.setItem("OriginalUrl",this.router.url);
      //alert(this.router.url);
      this.authenticatedReceiptDownloadDetailsSnapShot=this.route.snapshot.data.authenticatedReceiptDownloadDetails;
      let downloadedOrNot= this.authenticatedReceiptDownloadDetailsSnapShot.ResultContent.IsReceiptDownloaded;
      let isReceiptExpired= this.authenticatedReceiptDownloadDetailsSnapShot.ResultContent.IsReceiptExpired;
      this.responseMessage=this.messageDetailsSnapShot.ResultContent.ResponseMessage;
      this.receiptVerifiedEmailDownloadMaxHours=this.messageDetailsSnapShot.ResultContent.ReceiptVerifiedEmailDownloadMaxHours;
      //this.receiptExpiredNote=this.langSvc.instant('DownloadAuthenticatedReceipt.Note');
      //this.receiptExpiredNote=this.receiptExpiredNote.replace("<hr>",this.receiptVerifiedEmailDownloadMaxHours.toString());
      if(downloadedOrNot)
      {

        this.IsFileAlreadyDownloaded=downloadedOrNot;
      }
      else if (isReceiptExpired)
      {

        this.IsReceiptExpired=isReceiptExpired;;
      }
    }
    else
    {
      this.appLang='en-us';
    }
    this.langSvc.setDefaultLang(this.appLang);
    localStorage.setItem('appLang',this.appLang);
    this.initLang();
    this.commonUtilSvc.hideSpinner();
    
  }

  initLang() {
    const lang =  this.user.getAppLanguage();
    const browserLang = navigator.language.toLowerCase();
    if (lang === browserLang) {
      this.langLoaderSvc.use(lang);
      this.appLang = lang;
    } else {
      this.langLoaderSvc.use(lang);
      this.appLang = browserLang;
    }
  }

  GetTodaysDate() {
    var x = new Date();
    var y = x.getFullYear().toString();
    var m = (x.getMonth() + 1).toString();
    var d = x.getDate().toString();
    (d.length == 1) && (d = '0' + d);
    (m.length == 1) && (m = '0' + m);
    var yyyymmdd = y + m + d;
    return yyyymmdd;
}
  

  ValidateAndDownloadAuthenticatedReceipt()
  {
    this.commonUtilSvc.showSpinner();

    let downloadedOrNot:boolean;
    let isReceiptExpired:boolean;
    this.largeReceiptService.isAuthenticatedReceiptDownloadedOrNot(this.historyId)
    .subscribe(async resp => {
      if (!(resp instanceof AppError)) {      
        
        const response = resp as IReceiptDownloadDetails;
         const result = await response.ResultContent;
         this.resultContentObjDownload=result;
         downloadedOrNot=this.resultContentObjDownload.IsReceiptDownloaded;
         isReceiptExpired=this.resultContentObjDownload.IsReceiptExpired;
         
         this.commonUtilSvc.hideSpinner();
         if(!downloadedOrNot && !isReceiptExpired)
         {
            this.downloadAuthenticatedReceipt();

         }
         else if(downloadedOrNot)
          {

            this.IsFileAlreadyDownloaded=downloadedOrNot;
          }
          else if (isReceiptExpired)
          {

            this.IsReceiptExpired=isReceiptExpired;
          }


    }
  });
  
    
    

  }

  downloadAuthenticatedReceipt()
  {
    $("#divDownloading").css("display","block");
    $('#btnDownload').prop('disabled', true);
    //this.commonUtilSvc.showSpinner();
    window.location.href=this.largeReceiptService.downloadAuthenticatedReceiptByUrl(this.historyId);
    //this.commonUtilSvc.hideSpinner();
    const date = new Date();
    date.setSeconds( date.getSeconds() + 20 );
    document.cookie = "fileDwnld"+"="+1+"; expires="+date+"; path=/";
    this.commonUtilSvc.setCookie('fileDwnld');
  }

  downloadAuthenticatedReceiptOld()
  {
    this.commonUtilSvc.showSpinner();
    this.subs.sink = this.largeReceiptService.downloadAuthenticatedReceipt(this.historyId)
        .subscribe(data => {
          if (!(data instanceof AppError)) {     
            
            const blob = new Blob([data], {
              type: 'application/zip',  
            });

            var a = document.createElement("a");
            document.body.appendChild(a);
          
            this.IsFileDownloaded=true;
            let fileName=this.historyId+"_"+ this.GetTodaysDate()+".zip";
            //if it is IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
          } 
          else
          {
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            a.click();
            //window.URL.revokeObjectURL(url);
            setTimeout(function(){
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(url);
            }, 100);
            this.commonUtilSvc.hideSpinner();
            
          }

          }
          
        });
  }
}


